import React, { Suspense, lazy, memo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';
import AgeVerification from './components/AgeVerification';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const Comparison = lazy(() => import('./pages/Comparison'));
const Winamax = lazy(() => import('./pages/Winamax'));
const Olybet = lazy(() => import('./pages/Olybet'));
const Genybet = lazy(() => import('./pages/Genybet'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Contact = lazy(() => import('./pages/Contact'));
const About = lazy(() => import('./pages/About'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

// Loading component - memoized for performance
const Loading: React.FC = memo(() => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
  </div>
));
Loading.displayName = 'Loading';

function App() {
  return (
    <Router>
      <AgeVerification />
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/comparaison" element={<Comparison />} />
            <Route path="/winamax" element={<Winamax />} />
            <Route path="/olybet" element={<Olybet />} />
            <Route path="/genybet" element={<Genybet />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/politique-cookies" element={<CookiePolicy />} />
            <Route path="/conditions-utilisation" element={<TermsOfService />} />
          </Routes>
        </Suspense>
      </Layout>
      <CookieConsent />
    </Router>
  );
}

export default App;
